var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SfButton',{staticClass:"back-button",on:{"click":_vm.handleClick}},[_c('SfIcon',[_c('IconsArrowleftArrowLeft24px')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }